<template>
    <nav class="navbar is-fixed-top has-shadow" aria-label="main navigation">
        <div class="navbar-brand">
            <a class="navbar-item" href="#">
                <img src="../assets/personal-logo.png" width="112" height="28" alt="Conor O'Rirodan">
            </a>
            <a role="button" class="navbar-burger burger" aria-label="menu" :aria-expanded="isOpen" data-target="mainnavbartabs" :class="{'is-active':isOpen}" @click="toggleNav">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
      
        <div id="mainnavbartabs" class="navbar-menu" :class="{'is-active':isOpen}">
            <div class="navbar-start">
                <a class="navbar-item" tabindex="0" @click="scrollTo('mainProjects')" @keyup.enter="scrollTo('mainProjects')">Main Projects</a>
                <a class="navbar-item" tabindex="0" @click="scrollTo('sideProjects')" @keyup.enter="scrollTo('sideProjects')">Side Projects</a>
                <a class="navbar-item" tabindex="0" @click="scrollTo('contactMe')" @keyup.enter="scrollTo('contactMe')">Contact Me</a>
            </div>
        
          <div class="navbar-end">
            <div class="navbar-item">
                <div class="buttons">
                    <a class="button" href="http://cs.newpaltz.edu/~oriordac1/assets/Resume%20Fall%202020.pdf" target="_blank">
                        <span class="icon">
                            <i class="fas fa-file" aria-hidden="true"></i>
                        </span>
                        <span>Resume</span>
                    </a>
                    <a class="button is-info" href="https://www.linkedin.com/in/conor-o-riordan-730122134/" target="_blank" rel="noreferrer">
                        <span class="icon">
                            <i class="fab fa-linkedin-in" aria-hidden="true"></i>
                        </span>
                        <span>LinkedIn</span>
                    </a>
                    <a class="button is-dark" href="https://github.com/oriordac" target="_blank" rel="noreferrer">
                        <span class="icon">
                            <i class="fab fa-github" aria-hidden="true"></i>
                        </span>
                        <span>GitHub</span>
                    </a>
                </div>
            </div>
          </div>

        </div>
    </nav>
</template>

<script>
export default {
    data: () => ({
        isOpen: false
    }),
    methods: {
        toggleNav () {
            this.isOpen = !this.isOpen;
        },
        scrollTo (sectionName) {
            if(this.isOpen == true) {
                this.toggleNav();
            }
            this.$emit("scroll-to", sectionName, this.isOpen);
        }
    }
}
</script>

<style>

</style>